export const LS = {
  ROUTE: "route",
}
